export const INPUT_TYPES = {
  text: 'text',
  email: 'email',
  password: 'password',
  confirmationCode: 'confirmation-code'
};

export default { INPUT_TYPES };
